import { RouteType } from "../../../types/RouteType";

const laborEfficiencyReportRoute: RouteType = {
  name: "LaborEfficiencyReport",
  path: "/production/labor-efficiency",
  title: "Labor Efficiency Report",
  layout: "/app",
  group: "Production",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  viewportCard: {
    header: {
      component: () => import("./LaborEfficiencyReport.Header"),
      title: "Labor Efficiency Report",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./LaborEfficiencyReport"),
      grayBackground: true,
    },
  },
};

export default laborEfficiencyReportRoute;
